/**
 * SafetyCheck
 * The SafetyCheck API
 *
 * The version of the OpenAPI document: master-35d84d79-917289
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@nestjs/common';
import { HttpService } from '@nestjs/axios';
import { AxiosResponse } from 'axios';
import { Observable } from 'rxjs';
import { AreYouOkDto } from '../model/areYouOkDto';
import { AreYouOkResponseDto } from '../model/areYouOkResponseDto';
import { AreYouOkResponseSetDto } from '../model/areYouOkResponseSetDto';
import { AreYouOkUpdateDto } from '../model/areYouOkUpdateDto';
import { OpenedDto } from '../model/openedDto';
import { OpenedUpdateDto } from '../model/openedUpdateDto';
import { Configuration } from '../configuration';
import { COLLECTION_FORMATS } from '../variables';


@Injectable()
export class AreYouOkApi {

    protected basePath = 'http://.';
    public configuration = new Configuration();

    constructor(protected httpClient: HttpService, @Optional() configuration: Configuration) {
        this.configuration = configuration || this.configuration;
        this.basePath = configuration?.basePath || this.basePath;
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        return consumes.includes(form);
    }

    /**
     * 
     * 
     * @param accessCode 
     * @param areYouOkResponseSetDto 
     */
    public createPendingResponse(accessCode: string, areYouOkResponseSetDto: AreYouOkResponseSetDto, ): Observable<AxiosResponse<AreYouOkResponseDto>>;
    public createPendingResponse(accessCode: string, areYouOkResponseSetDto: AreYouOkResponseSetDto, ): Observable<any> {

        if (accessCode === null || accessCode === undefined) {
            throw new Error('Required parameter accessCode was null or undefined when calling createPendingResponse.');
        }

        if (areYouOkResponseSetDto === null || areYouOkResponseSetDto === undefined) {
            throw new Error('Required parameter areYouOkResponseSetDto was null or undefined when calling createPendingResponse.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.put<AreYouOkResponseDto>(`${this.basePath}/are-you-ok/${encodeURIComponent(String(accessCode))}/pendingResponse`,
            areYouOkResponseSetDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param accessCode 
     */
    public deletePendingResponse(accessCode: string, ): Observable<AxiosResponse<AreYouOkResponseDto>>;
    public deletePendingResponse(accessCode: string, ): Observable<any> {

        if (accessCode === null || accessCode === undefined) {
            throw new Error('Required parameter accessCode was null or undefined when calling deletePendingResponse.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.delete<AreYouOkResponseDto>(`${this.basePath}/are-you-ok/${encodeURIComponent(String(accessCode))}/pendingResponse`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param state 
     */
    public findAll(state?: Array<'draft' | 'ongoing' | 'done' | 'archived' | 'deleted'>, ): Observable<AxiosResponse<Array<AreYouOkDto>>>;
    public findAll(state?: Array<'draft' | 'ongoing' | 'done' | 'archived' | 'deleted'>, ): Observable<any> {


        let queryParameters = new URLSearchParams();
        if (state) {
            state.forEach((element) => {
                queryParameters.append('state', <any>element);
            })
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // authentication (bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers['Authorization'] = 'Bearer ' + accessToken;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<Array<AreYouOkDto>>(`${this.basePath}/are-you-ok`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param accessCode 
     */
    public getAreYouOk(accessCode: string, ): Observable<AxiosResponse<AreYouOkDto>>;
    public getAreYouOk(accessCode: string, ): Observable<any> {

        if (accessCode === null || accessCode === undefined) {
            throw new Error('Required parameter accessCode was null or undefined when calling getAreYouOk.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<AreYouOkDto>(`${this.basePath}/are-you-ok/${encodeURIComponent(String(accessCode))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param accessCode 
     */
    public getPendingResponse(accessCode: string, ): Observable<AxiosResponse<AreYouOkResponseDto>>;
    public getPendingResponse(accessCode: string, ): Observable<any> {

        if (accessCode === null || accessCode === undefined) {
            throw new Error('Required parameter accessCode was null or undefined when calling getPendingResponse.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        return this.httpClient.get<AreYouOkResponseDto>(`${this.basePath}/are-you-ok/${encodeURIComponent(String(accessCode))}/pendingResponse`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param accessCode 
     * @param areYouOkUpdateDto 
     */
    public updateAreYouOk(accessCode: string, areYouOkUpdateDto: AreYouOkUpdateDto, ): Observable<AxiosResponse<AreYouOkDto>>;
    public updateAreYouOk(accessCode: string, areYouOkUpdateDto: AreYouOkUpdateDto, ): Observable<any> {

        if (accessCode === null || accessCode === undefined) {
            throw new Error('Required parameter accessCode was null or undefined when calling updateAreYouOk.');
        }

        if (areYouOkUpdateDto === null || areYouOkUpdateDto === undefined) {
            throw new Error('Required parameter areYouOkUpdateDto was null or undefined when calling updateAreYouOk.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.patch<AreYouOkDto>(`${this.basePath}/are-you-ok/${encodeURIComponent(String(accessCode))}`,
            areYouOkUpdateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
    /**
     * 
     * 
     * @param accessCode 
     * @param openedUpdateDto 
     */
    public updateAreYouOkOpened(accessCode: string, openedUpdateDto: OpenedUpdateDto, ): Observable<AxiosResponse<OpenedDto>>;
    public updateAreYouOkOpened(accessCode: string, openedUpdateDto: OpenedUpdateDto, ): Observable<any> {

        if (accessCode === null || accessCode === undefined) {
            throw new Error('Required parameter accessCode was null or undefined when calling updateAreYouOkOpened.');
        }

        if (openedUpdateDto === null || openedUpdateDto === undefined) {
            throw new Error('Required parameter openedUpdateDto was null or undefined when calling updateAreYouOkOpened.');
        }

        let headers: Record<string, string> = {};
        if (this.configuration.defaultHeaders) {
          headers = typeof this.configuration.defaultHeaders === 'function'
          ? this.configuration.defaultHeaders()
          : this.configuration.defaultHeaders;
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }
        return this.httpClient.put<OpenedDto>(`${this.basePath}/are-you-ok/${encodeURIComponent(String(accessCode))}/opened`,
            openedUpdateDto,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers
            }
        );
    }
}
